export enum UiStyle {
    Box = 0,
    Bootstrap = 1,
    Material = 2,
}
